module.exports = __webpack_public_path__ + "assets/favicon-32.png";


//////////////////
// WEBPACK FOOTER
// ./images/favicon-32.png
// module id = 153
// module chunks = 0